import { AnchorButton, Button, Classes, Dialog, Intent, Popover, Position, Tooltip } from "@blueprintjs/core";
import * as React from "react";
import NumberFormat from 'react-number-format';
import {
  anchorButtonStyle, cancelButtonStyle, dialogFooter, flexColumn, flexRow, footerActions, labelContainer, labelSettings,
  nonParDialogBody, nonParGeneralStyles, phoneNumberDiv, providerNameInput, providerNumberContainer, providerNumberDiv,
  inputSettings, requiredColor, requiredMessage, tripPriceContainer, tripPriceDiv, tripPriceInput
} from "../../styles";


class DialogNonParComplete extends React.PureComponent {

  state = {
    providerName: '',
    providerPhoneNumber: '',
    providerPrice: '$0',
    isOpen: true,
    isConfirmDisabled: true,
    isProviderNameOk: false,
    isProviderPhoneOk: false,
    providerNameErrorMessage: 'This field must contain more than 0 and less than 40 characters',
    phoneNumberErrorMessage: 'This field must contain 10 numbers',
    providernameError: false,
    providerPhoneNumberError: false,
  }

  lengthValidations = (event) => {
    const prov = event.target.value;
    const name = event.target.name;
    this.setState({
      providerName: prov,
      isProviderNameOk: prov.length > 0 && prov.length <= 40,
      [name + 'Error']: prov.length <= 0 || prov.length > 40,
    })
  }

  numberValidations = (event) => {
    const phone = event.target.value;
    const name = event.target.name;
    this.setState({
      providerPhoneNumber: phone,
      isProviderPhoneOk: !phone.includes('_') && phone,
      [name + 'Error']: phone.includes('_') || !phone,
    })
  }

  handlePriceChange = (event) => {
    let price = event.target.value;

    if (!price) {
      price = "$0";
    }

    this.setState({
      providerPrice: price
    });
  }

  handleConfirm = () => {
    this.handleClose();
  }

  render() {
    return (
      <Dialog
        onClose={this.handleClose}
        {...this.state}
        style={nonParGeneralStyles}
      >
        <form>
          <div className={Classes.DIALOG_BODY} style={nonParDialogBody}>
            <div>
              <label style={labelContainer}>
                <div style={flexColumn}>
                  <div style={flexRow}>
                    <h3><strong>Insert the Provider name</strong></h3><h3 style={requiredColor}>*</h3>
                  </div>
                  <div>
                    <Popover className=".bp3-popover-backdrop" isOpen={this.state.providernameError} content={this.state.providerNameErrorMessage} position={Position.BOTTOM_LEFT}>
                      <></>
                    </Popover>
                    <input
                      className="bp3-input .bp3-fill .modifier form-control"
                      value={this.state.providerName}
                      name="providername"
                      placeholder="Transportation Provider"
                      onChange={this.lengthValidations}
                      dir="auto"
                      style={providerNameInput}
                    />
                  </div>
                </div>
              </label>
            </div>
            <div style={providerNumberDiv}>
              <label style={labelSettings}>
                <div style={providerNumberContainer}>
                  <div style={flexRow}>
                    <h3><strong>Insert the Provider number</strong></h3><h3 style={requiredColor}>*</h3>
                  </div>
                  <div style={phoneNumberDiv}>
                    <Popover className=".bp3-popover-backdrop"
                      isOpen={this.state.providerPhoneNumberError}
                      content={this.state.phoneNumberErrorMessage}
                      position={Position.TOP_LEFT}
                    >
                      <></>
                    </Popover>
                    <NumberFormat
                      format="+1 (###) ###-####"
                      mask="_"
                      value={this.state.providerPhoneNumber}
                      name="providerPhoneNumber"
                      placeholder="Phone Number"
                      prefix={'+'}
                      style={inputSettings}
                      onChange={this.numberValidations}
                    />

                  </div>
                </div>
              </label>
            </div>
            <div style={labelContainer}>
              <label style={labelSettings}>
                <div style={tripPriceContainer}>
                  <div style={flexRow}>
                    <h3><strong>Insert the trip price</strong></h3>
                  </div>
                  <div style={tripPriceDiv}>
                    <NumberFormat
                      thousandSeparator={true}
                      decimalScale={2}
                      placeholder="$ 0.00"
                      onChange={this.handlePriceChange}
                      prefix={'$'}
                      style={tripPriceInput}
                    />
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div style={dialogFooter} className={Classes.DIALOG_FOOTER}>
            <div style={footerActions} className={Classes.DIALOG_FOOTER_ACTIONS}>
              <div>
                <p style={requiredMessage}>*Fields required.</p>
              </div>
              <div>
                <AnchorButton
                  intent={Intent.PRIMARY}
                  target="_blank"
                  style={anchorButtonStyle}
                  onClick={this.handleConfirm}
                  disabled={!(this.state.isProviderNameOk && this.state.isProviderPhoneOk)}
                >
                  <strong>Save</strong>
                </AnchorButton>
                <Tooltip>
                  <Button style={cancelButtonStyle}
                    onClick={this.handleClose}>
                    <strong>Cancel</strong>
                  </Button>
                </Tooltip>
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    );
  }

  handleOpen = () => this.setState({ isOpen: true });
  handleClose = () => {
    this.setState({ isOpen: false });

    this.props.onModalClosed(this.props.id);
  }
}

export default DialogNonParComplete;
